import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { /*object_type,*/ api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from './../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import parse from 'html-react-parser';
//import ReactHtmlParser from 'react-html-parser';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	handle_compressed_image_upload,
	passwordHash,
	pattern_email,
	pattern_vat
	//set_darkmode,

} from '../../../Utils';

import Hosts from '../../../Hosts';

import { language } from './Language';
//import { el } from 'date-fns/locale';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [dados_course, set_dados_course] = useState('');

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [is_uploading, set_is_uploading] = useState( { profile_picture: ' d-none', id: ' d-none', certificate: ' d-none', iban: ' d-none', emprego: ' d-none', emprego_horario: ' d-none', desempregado: ' d-none' })
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0)

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, set_is_password] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [disabled, set_disabled] = useState(true)
	const [/*is_input_disabled*/, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	const [course_registration_operation_save, set_course_registration_operation_save] = useState(false)
	const [course_registration_operation, set_course_registration_operation] = useState(false)
	const [financed_course_registration_operation, set_financed_course_registration_operation] = useState(false)

	const delete_permission = ('trainee_user' !== getTokenInfo().profile);

	const [files_upload, set_files_upload] = useState([]);
	const [files_image, set_files_image] = useState([]);
	const [files_upload_name, set_files_upload_name] = useState([]);
	const [image_base64, set_image_base64] = useState([]);

	const [input_file_id, set_input_file_id] = useState(false);
	const [input_file_certificate, set_input_file_certificate] = useState(false);
	const [input_file_iban, set_input_file_iban] = useState(false);
	const [/*input_file_emprego*/, set_input_file_emprego] = useState(false);
	const [/*input_file_emprego_horario*/, set_input_file_emprego_horario] = useState(false);
	const [/*input_file_desempregado*/, set_input_file_desempregado] = useState(false);

	const aQualificacaoNivel = [
        { value: '0', level: "0", label: "Não sabe ler nem escrever"},
        { value: '1', level: "0", label: "< 4.º ano" },
        { value: '2', level: "0", label: "1.º ciclo (4.º ano)" },
        { value: '3', level: "1", label: "2.º ciclo (6.º ano)" },
        { value: '4', level: "2", label: "3.º ciclo (9.º ano)" },
        { value: '5', level: "3", label: "Ensino Secundário" },
        { value: '6', level: "4", label: "Ensino Secundário Dupla Certificação" },
        { value: '7', level: "5", label: "Ensino Pós-Secundário não superior" },
        { value: '8', level: "5", label: "Cursos superiores de curta duração" },
        { value: '9', level: "6", label: "Bacharelato/Licenciatura" },
        { value: '10', level: "6", label: "Pós-Graduação" },
        { value: '11', level: "6", label: "Bacharelato" },
        { value: '12', level: "6", label: "Licenciatura" },
        { value: '13', level: "6", label: "Licenciatura pré-Bolonha" },
        { value: '14', level: "7", label: "Mestrado Integrado" },
        { value: '15', level: "7", label: "Mestrado Pré-Bolonha" },
        { value: '16', level: "7", label: "Mestrado" },
        { value: '17', level: "8", label: "Doutoramento" }
    ];

	const situacao_emprego = [
		'À procura do 1.º emprego', 
		'Desempregado de longa duração (> 12 meses)', 
		'Desempregado à procura de novo emprego (não DLD)', 
		'Empregado por conta própria', 
		'Empregado por conta de outrem'
  	] ;

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const fetch_id_info_course = async (id) => {

		return await reqGET(`${api_crud_base}/formation/course/${getTokenInfo().companycode}/${id}`)
			.then(res => {
				set_dados_course(res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.office = getTokenInfo().office)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;


			if (test === 'edit') {
				set_is_input_disabled(false)
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				if(props.location.state.secondary_operation !== undefined) {

					if(props.location.state.course_financed === true){

						set_financed_course_registration_operation(true)

					}
					
					set_course_registration_operation(true)

					fetch_id_info_course(props.location.state.course_id).then(() => setLoading(false))
				}

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
					if(props.location.state.secondary_operation !== undefined) { 
						/*Swal.fire({
							title: language[lang].formation_registration_finish,
							html:  language[lang].formation_registration_finish_warning,
							icon: 'warning',
						})*/
						Swal.fire(language[lang].formation_registration_finish, language[lang].formation_registration_finish_warning, 'warning')
					}
					checkInputFiles()
				})
				return
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props, lang])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			//console.log(course_registration_operation_save)
			//console.log(props.location.state.secondary_operation)

			/*if(course_registration_operation_save) {
				checkInputFiles()
			}*/

			checkFieldValidation()

			let terms_conditions_link = language[lang].edit_text_2 + '<a href="' + Hosts.WEB_SITE_URI + 'terms-conditions" target="_blank" rel="noreferrer">' + language[lang].terms_conditions_link + '</a></br>' + language[lang].edit_text;
			//let terms_conditions_link = `${language[lang].edit_text_2}<a href="${Hosts.WEB_SITE_URI}terms-conditions" target="_blank" rel="noreferrer">${language[lang].terms_conditions_link}</a></br>${language[lang].edit_text}`;
			//console.log(terms_conditions_link)

			if(course_registration_operation_save && props.location.state.secondary_operation !== undefined) {

				//console.log(financed_course_registration_operation)
				//console.log(input_file_id)

				if((!financed_course_registration_operation && course_registration_operation_save) && (input_file_id === false || input_file_certificate === false)) {
					Swal.fire(language[lang].formation_registration_finish, language[lang].formation_registration_required_files_warning1, 'warning')
					/*Swal.fire({
						title: language[lang].formation_registration_finish,
						html: language[lang].formation_registration_required_files_warning1,
						icon: 'warning'
					})*/

					set_course_registration_operation_save(false)
				
				}
				else if((financed_course_registration_operation && course_registration_operation_save) && (input_file_id === false || input_file_certificate === false || input_file_iban === false)){
					Swal.fire(language[lang].formation_registration_finish, language[lang].formation_registration_required_files_warning2, 'warning')

					set_course_registration_operation_save(false)
				}
				else{
					Swal.fire({
						title: language[lang].formation_registration_finish,
						html: language[lang].formation_registration_finish_text + '<b>' + props.location.state.course_name + '.</b></br>' + terms_conditions_link,
						icon: 'question',
						showCancelButton: true,
						confirmButtonColor: '#0095e8',
						cancelButtonColor: '#d9214e',
						confirmButtonText: language[lang].edit_confirm,
						cancelButtonText: language[lang].edit_cancel
					})
					.then((result) => {
						if (result.isConfirmed) {

							let data = new Date()

							if(is_password) {
								let password = new_password;
								dados.current.info.password = passwordHash(password);
							}

							files_upload.forEach(async (el_upload) => {
								if (el_upload !== null) {
									await uploadFiles(el_upload.files, 'doc')
								}
							})
							set_files_upload([])
							set_files_upload_name([])

							files_image.forEach(async (el_upload) => {
								if (el_upload !== null) {
									await uploadFiles(el_upload.files, 'image')
								}
							})

							set_files_image([])
							set_image_base64([])

							if(dados.current.info['courses'] === undefined)
								dados.current.info['courses'] = []
						
							dados.current.info.courses.push(
								{ 
									course_id: props.location.state.course_id,
									course_name: props.location.state.course_name,
									course_financed: props.location.state.course_financed,
									request_status: 'under_review',
									request_date: data,
									request_response_date: ''
								}
							);

							reqPUT(api_crud_route, dados.current)
								.then(() => {
									set_new_password('')
									set_confirm_password('')

									if(dados_course.content[0]['candidates'] === undefined)
										dados_course.content[0]['candidates'] = []
								
									dados_course.content[0].candidates.push(
										{ 
											trainee_id: dados.current.id,
											trainee_name: dados.current.info.name + ' ' + dados.current.info.surname,
											trainee_email: dados.current.info.email,
											trainee_notified: false,
											trainee_status: 'under_review',
											trainee_request_date: data,
											trainee_response_date: ''
											//last_modification_date: data
										}
									);

									//reqPUT(`${api_crud_base}/formation/course/${getTokenInfo().companycode}/${props.location.state.course_id}`, dados_course)
									reqPUT(api_crud_base + '/formation/course', dados_course)
										.then(() => {
											
											Swal.fire({
												title: language[lang].formation_registration,
												html: language[lang].formation_registration_success,
												icon: 'success'
											})

											if(course_registration_operation_save)
												props.history.push('/courses_list');

										})
										.catch((error) => { 
											Swal.fire(language[lang].formation_registration_finish_error, '', 'info')
											console.log('ERROR UPDATING FORMATION DATA: ', error)
										})
								})
								.catch((error) => { 
									Swal.fire(language[lang].formation_registration_finish_error, '', 'info')
									console.log('ERROR UPDATING TRAINEE DATA: ', error)
								})
						}
					})
				}
			}
			else {

				Swal.fire({
					title: language[lang].edit_title,
					html: ('trainee_user' !== getTokenInfo().profile) ? language[lang].edit_text : terms_conditions_link,
					icon: 'question',
					showCancelButton: true,
					confirmButtonColor: '#0095e8',
					cancelButtonColor: '#d9214e',
					confirmButtonText: language[lang].edit_confirm,
					cancelButtonText: language[lang].edit_cancel
				})
				.then((result) => {
					if (result.isConfirmed) {

						files_upload.forEach(async (el_upload) => {
							if (el_upload !== null) {
								await uploadFiles(el_upload.files, el_upload.type, 'doc')
							}
						})
						set_files_upload([])
						set_files_upload_name([])

						files_image.forEach(async (el_upload) => {
							if (el_upload !== null) {
								await uploadFiles(el_upload.files, el_upload.type, 'image')
							}
						})

						set_files_image([])
						set_image_base64([])

						if(is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPUT(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')
								
								if(props.location.state.secondary_operation !== undefined) {
									set_course_registration_operation_save(true)
									setRefresh(refresh + 1)
								}

								//props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

			}

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					if(is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							set_new_password('')
							set_confirm_password('')
							
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqPUT(api_crud_route, dados.current)
					.then(() => { 
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
			}
		})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(res => {
						props.history.push(endpoints.list);
					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};

	const checkFieldValidation = () => {

		//console.log('checkFieldValidation agree', agree)
	
		let input01 = (dados.current.addresses[0].address !== '')
		let input02 = (dados.current.addresses[0].postal_code !== '')
		let input03 = (dados.current.addresses[0].location !== '')
		let input04 = (dados.current.addresses[0].village !== '')
		let input05 = (dados.current.addresses[0].municipality !== '')
		let input06 = (dados.current.info.date_birth !== '')
		let input07 = (dados.current.info.age !== '')
		let input08 = (dados.current.addresses[0].place_birth !== '')
		let input09 = (dados.current.info.id_number !== '')
		let input10 = (dados.current.info.id_validity !== '')
		let input11 = (dados.current.info.nif !== '')
		let input12 = (dados.current.info.nib_iban !== '')
		let input13 = (dados.current.info.qualifications.id !== '' && dados.current.info.qualifications.name !== '' && dados.current.info.qualifications.level !== '')
		let input14 = (dados.current.info.formation_area !== '')
		let input15 = (dados.current.info.employment.employment_status !== '')

		//let aFileTypes = ['id', 'certificate', 'iban', 'emprego']

		//let input_file_id = false

		//let input_file_certificate = false

		//let input_file_iban = false

		//let input_file_emprego = false

		//let input_file_emprego_horario = false

		//let input_file_desempregado = false

		//setRefresh(refresh + 1)

		//console.log(input_file_id)
		//console.log(input_file_certificate)
		//console.log(input_file_iban)
		//console.log(input_file_emprego)
		//console.log(input_file_emprego_horario)
		//console.log(input_file_desempregado)

		if(input01 && input02 && input03 && input04 && input05 && input06 && input07
			&& input08 && input09 && input10 && input11 && input12 && input13 && input14 && input15
			&& input_file_id === true && input_file_certificate === true && input_file_iban === true) {

				console.log('validação curso financiado')
				dados.current.info.funded_course_validation = true
				dados.current.info.non_funded_course_validation = true

		}else if(input01 && input02 && input03 && input04 && input05 && input06 && input07
			&& input08 && input09 && input10 && input11 /*&& input12 === false*/ && input13 && input14 && input15
			&& input_file_id === true && input_file_certificate === true) {

				console.log('validação curso não financiado')
				dados.current.info.non_funded_course_validation = true
				dados.current.info.funded_course_validation = false
				
		}else{

			console.log('sem validação para cursos')
			dados.current.info.non_funded_course_validation = false
			dados.current.info.funded_course_validation = false

		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current info:' + JSON.stringify(dados))
	
	}

	const checkInputFiles = async () => {

		let aFileTypes = ['id', 'certificate', 'iban', 'emprego', 'emprego-horario', 'desempregado']

		/*if(dados.current.info['files'] === undefined) {
			dados.current.info['files'] = []
		}*/

			
		if(dados.current.info.files !== undefined && dados.current.info.files.length > 0) {

			dados.current.info.files.forEach((f) => {
				
				if(aFileTypes.includes(f.type) && f.type !== '') {

					if(f.type === 'id'){
						//input_file_id = true
						set_input_file_id(true)
					}
					if(f.type === 'certificate'){
						//input_file_certificate = true
						set_input_file_certificate(true)
					}
					if(f.type === 'iban'){
						//input_file_iban = true
						set_input_file_iban(true)
					}
					if(f.type === 'emprego'){
						//input_file_emprego = true
						set_input_file_emprego(true)
					}
					if(f.type === 'emprego-horario'){
						//input_file_emprego_horario = true
						set_input_file_emprego_horario(true)
					}
					if(f.type === 'desempregado'){
						//input_file_desempregado = true
						set_input_file_desempregado(true)
					}


				}
			})

			setRefresh(refresh + 1)

		}

		/*files_upload_name.forEach((f) => {
				
			if(aFileTypes.includes(f.type) && f.type !== '') {

				if(f.type === 'id'){

					console.log('aki 1')
					//input_file_id = true
					set_input_file_id(true)
				}
				if(f.type === 'certificate'){
					//input_file_certificate = true
					set_input_file_certificate(true)
				}
				if(f.type === 'iban'){
					//input_file_iban = true
					set_input_file_iban(true)
				}
				if(f.type === 'emprego'){
					//input_file_emprego = true
					set_input_file_emprego(true)
				}
				if(f.type === 'emprego-horario'){
					//input_file_emprego_horario = true
					set_input_file_emprego_horario(true)
				}
				if(f.type === 'desempregado'){
					//input_file_desempregado = true
					set_input_file_desempregado(true)
				}


			}
		})*/

		setRefresh(refresh + 1)
	
	}

	const check_entity_field = async (field, value, entity) => {
		let search_string = ''

		if (entity === '') {
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`
		}
		else
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`

		reqGET(search_string)
			.then(res => {
				//console.log(res.data)

				let ja_existe = false
				let user_id = ''

				if(props.location.state !== undefined && is_edit) {
					user_id = props.location.state.item['id']
				}

				res.data.forEach((k) => {
					if (k[field] === value && value !== '' && k['id'] !== user_id) {

						ja_existe = true
					}
				})

				if (ja_existe === false) {
					set_is_input_disabled(true)

					if (field === 'username') {
						set_is_input_disabled(false)
					}
					return

				} else {
					//set_disabled(true)

					set_dados(dados.current.info[field] = '');

					Swal.fire({
						title: language[lang].warning_title,
						text: (field === 'email' ? language[lang].warning_text_2 : language[lang].warning_text_1),
						icon: 'warning',
						showCancelButton: false,
						confirmButtonColor: '#0095e8',
						cancelButtonColor: '#d9214e',
						confirmButtonText: language[lang].warning_confirm,
						cancelButtonText: language[lang].warning_cancel
					})
					.then((result) => {
						if (result.isConfirmed) {
							set_is_input_disabled(true)
							//set_disabled(false)
						}
					})

				}
			})
	}

	const checkEmailValidation = (data, name) => {

		const pattern_email_validation = /^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$/;
	
		if(pattern_email_validation.test(data) === false){
			set_dados(dados.current.info[name] = '');
			//setRefresh(refresh + 1)

			Swal.fire({
				title: (name === 'email' ? language[lang].contact_email : language[lang].username_email),
				text: language[lang].email_error_message,
				icon: 'warning',
				showCancelButton: false,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].warning_confirm,
				cancelButtonText: language[lang].warning_cancel
			})
	
			/*confirmAlert({
			  title: language[lang].username_email,
			  message: language[lang].email_error_message,
			  buttons: [
				{
				  label: language[lang].back,
				  onClick: () => { return }
				}
	
			  ]
			});*/
		}
	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current info:' + JSON.stringify(dados))
	}

	const handle_change_info_2 = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)

		if ((name === 'email') && value !== '') {
			
			checkEmailValidation(value, 'email')
			check_entity_field('email', value, '')
			
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current info:' + JSON.stringify(dados))
	}

	const handle_change_addresses = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
	
		//console.log('NAME:' + name)
		//console.log('Value:' + value)
		
		set_dados(dados.current.addresses[index][name] = value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current adresses:' + JSON.stringify(dados))

	}

	const handle_change_info_qualifications = e => {
        const { value, dataset } = e.target;
        const { level, name } = dataset;

		if(dados.current.info['qualifications'] === undefined) {
			dados.current.info.qualifications = {
				id: '',
				level: '',
				name: '',
			}
		}

        set_dados( dados.current.info.qualifications.id = value );
        set_dados( dados.current.info.qualifications.level = level );
        set_dados( dados.current.info.qualifications.name = name );

  		console.log('Dados Current Qualifications:' + JSON.stringify(dados))
    }

	const handle_change_info_employment = ( e ) => {
		const { name , value } = e.target ;

		if(dados.current.info['employment'] === undefined) {
			dados.current.info.employment = {
				employment_status: '',
				employer_entity: '',
				business_sector : '',
				employment_role: '',
				iefp_registration_date: ''
			}
		}

		/*if(dados.current.info.employment[name] === undefined){
			dados.current.info.employment[name] = ''
		}*/

		set_dados(dados.current.info.employment[name] = value);

		console.log('Dados Current Emprego:' + JSON.stringify(dados))
	};

	const handle_change_info_household = (e) => {
		const { name , value } = e.target;

		if(dados.current.info['household'] === undefined) {
			dados.current.info.household = {
				household_inactive: '',
            	household_dependants: '',
            	household_total: '',
            	household_unemployed: '',
			}
		}

		set_dados( dados.current.info.household[ name ] = value )

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current agregado:' + JSON.stringify(dados))
	 
	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		check_entity_field('username', value, '')

		if('Administrador' !== getTokenInfo().profile) {
      
			checkEmailValidation(value, 'username')
		}
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if(new_password === value) {
			set_is_password(true)
			//set_disabled(false)
		}
		else {
			Swal.fire(language[lang].password_text, '', 'info')
			set_is_password(false)
			//set_disabled(true)
		}
	}

	const convertBase64 = async (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
        
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
        
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

	const onChangeHandlerFile = (e) => {
		const { files, dataset } = e.target;
		const { type } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux = files_upload_name
				aux.push({ name: v.name, type: type })
				set_files_upload_name(aux)

				if(dados.current.info['files'] === undefined) {
					dados.current.info['files'] = []
				}

				dados.current.info['files'] = dados.current.info['files'].filter(el_f => el_f.type !== type)

				set_dados(dados.current,)
				//setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_upload.filter((el) => el.type !== type)
		files_aux.push({ files: storedFiles, type: type })
		set_files_upload(files_aux)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current files:' + JSON.stringify(dados))
	}

	const onChangeHandlerImage = (e) => {
		const { files, dataset } = e.target;
		const { type } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {

			//console.log(v.type)
			if((v.type.includes('image/')) && (v.size < 10485760)){

				handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				const base64 = await convertBase64(v);
				
				let files_img_aux = image_base64
				
				files_img_aux = [{id: '1', name: v.name, type: type, link: base64}]
				set_image_base64(files_img_aux)

				if(dados.current.info['files'] === undefined) {
					dados.current.info['files'] = []
				}

				dados.current.info['files'] = dados.current.info['files'].filter(el_f => el_f.type !== type)

				//if(filesArray.length === (k + 1)) {
					set_dados(dados.current,)
					setRefresh(refresh + 1)
				//}
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_image
		files_aux.push({ files: storedFiles, type: type })
		set_files_image(files_aux)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current files:' + JSON.stringify(dados))
	}

	const uploadFiles = (files, doc_type, type) => {
		let aux = []
		files.forEach((element) => {
			if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, doc_type, type)
					.then(() => {
						//console.log('success')
					})
			}
			if (element.type.includes('image/')) {
				aux.push(element)

				uploadFile(element, doc_type, type)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, doc_type, type) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'user')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/users/');

		//console.log('file.type', doc_type)

		let x_aux = is_uploading
		if(doc_type === 'profile-picture') {
			x_aux['profile_picture'] = ''
		}
		x_aux[doc_type] = ''
		set_is_uploading(x_aux)

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let x = {
					id: '',
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				if (type === 'doc') {

					if(dados.current.info['files'] === undefined) {
						dados.current.info['files'] = []
					}

					let aux = dados.current.info['files'].filter(el_f => el_f.type !== doc_type)
					aux.push({
						id: '',
						link: res.data.path + '/' + res.data.name,
						name: file.name,
						description: '',
						type: doc_type
					})
					dados.current.info['files'] = aux
				}

				if (type === 'image') {

					if(dados.current.info['files'] === undefined) {
						dados.current.info['files'] = []
					}

					let aux = dados.current.info['files'].filter(el_f => el_f.type !== doc_type)
					aux.push({
						id: '',
						link: res.data.path + '/' + res.data.name,
						name: file.name,
						description: '',
						type: doc_type
					})
					dados.current.info['files'] = aux
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 

						if(doc_type === 'profile-picture') {
							x_aux['profile_picture'] = ' d-none'
						}

						x_aux[doc_type] = ' d-none'
						set_is_uploading(x_aux)

						setRefresh(refresh + 1)
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const removeUserDocument = (type, index) => {
		//console.log('index do file: ', index)

		let del_value = dados.current.info.files.slice(index, index + 1);

		let document_file = dados.current.info.files.filter(v => v.type !== del_value[0].type);

		set_dados(dados.current.info.files = document_file)

		setRefresh(refresh + 1)

		console.log(dados.current.info.files)
	}

	const removeCourseRegistration = (course_id, index) => {
		//console.log('index da inscrição: ', index)

		let del_value = dados.current.info.courses.slice(index, index + 1);

		let courses = dados.current.info.courses.filter(v => v.course_id !== del_value[0].course_id);

		set_dados(dados.current.info.courses = courses)

		setRefresh(refresh + 1)

		//console.log(dados.current.info.courses)
	}

	return isloading ?
		
			<Loader />

		:

			isRedirect
				?
					<Redirect to={endpoints.list} replace />
				:
					<main>
						<div className={`dash-cards header`}>
							<h2 className="dash-title">{language[lang].entity}</h2>
							<span>
								{
									('trainee_user' !== getTokenInfo().profile) ?

										<Link to={{ pathname: endpoints.list }}  >
											{language[lang].entity}
										</Link>

									:
										language[lang].entity
								}
								&nbsp;&#47;&nbsp;
								{ dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new }
							</span>
						</div>
				
						<div className={`dash-cards body`}>
							<div className="container">
				
								<div className="row">
									<div className="mb-5">
										<div className="card">
											<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_info">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
												</div>
											</div>
											<div id="div_entidade_info" className="collapse show">
												<form id="form" onSubmit={handleSubmit}>

													<div className="card-body border-top p-4">
														<div className="row">
															<div className="col-12 mb-3">
																<label className="fw-bold">
																	{parse(language[lang].terms_conditions_required)}
																</label>
															</div>
															<div className="col-12 mb-3">
																<div className='row'>
																	<div className="col-12 col-sm-6 div-image">
																		<label className="col-form-label fw-bold fs-6">{language[lang].image_profile}</label>
																		<div className="dropzone-panel mb-2">
																			<div className="div-form-input custom-file">
																				<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-file-profile-picture"}>{language[lang].image_choose}</label>
																				<input 
																					id={"input-file-profile-picture"}
																					type="file" 
																					accept="image/*"
																					data-type={'profile-picture'}
																					className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
																					onChange={onChangeHandlerImage}
																				/> 
																				<div className={"spinner-border position-absolute" + is_uploading['profile_picture']} role="status">
																					<span className="visually-hidden">Loading...</span>
																				</div>
																				{
																					dados.current.info['files'] !== undefined ?
																						dados.current.info.files.map((el_f, k_f) => {
																							if(el_f.type === 'profile-picture') {
																								return (
																									<div key={k_f} className='col-12 col-sm-4 position-relative mt-3'>
																										<img className='img-fluid' alt={el_f.name} title={el_f.name} src={el_f.link} />
																										<span 
																											className="btn btn-icon rounded-0 bg-white border shadow m-1 position-absolute"
																											onClick={() => removeUserDocument(el_f.type, k_f)}
																											alt={language[lang].image_remove}
																											title={language[lang].image_remove}
																											style={{right: 0}}
																										>
																											<i className="bi bi-x fs-3"></i>
																										</span>
																									</div>
																								)
																							}
																							else {
																								return null
																							}
																						})
																					:
																						null
																				}

																				{
																					image_base64.map((el_f, k_f) => {
																						if(el_f.type === 'profile-picture') {
																							return (
																								<p key={k_f} className=' mt-3'>
																									<img style={{marginTop: '10px', maxWidth: '100%', maxHeight:'217px'}} alt={el_f.name} title={el_f.name} src={el_f.link} />
																								</p>
																							)
																						}
																						else {
																							return null
																						}
																					})
																				}
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div className="col-6 col-md-6 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].name}&nbsp;({language[lang].profile})<span className='text-danger'>&#42;</span></label>
																<input type="text" name="name" value={dados.current.info.name} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
															</div>

															<div className="col-6 col-md-6 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].surname}&nbsp;({language[lang].profile})<span className='text-danger'>&#42;</span></label>
																<input type="text" name="surname" value={dados.current.info.surname} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].surname_placeholder} onChange={handle_change_info} required />
															</div>

															<div className="col-12 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].name_full}<span className='text-danger'>&#42;</span></label>
																<input type="text" name="name_full" value={dados.current.info.name_full} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_full_placeholder} onChange={handle_change_info} required />
															</div>

															<div className="col-6 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].contact_email}<span className='text-danger'>&#42;</span></label>
																<input type="email" pattern={pattern_email} name="email" value={dados.current.info.email} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].contact_email_placeholder} onChange={handle_change_info} onBlur={handle_change_info_2} required />
															</div>
															<div className="col-6 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].phone_number}<span className='text-danger'>&#42;</span></label>
																<PhoneInput
																	defaultCountry="PT"
																	className="form-control mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].phone_number_placeholder}
																	value={dados.current.info.phone !== '' ? dados.current.info.phone : null}
																	onChange={e => set_dados(dados.current.info.phone = e)} 
																	required
																/>
																{/*<input type="tel" name="phone" pattern="[0-9]{9}" value={dados.current.info.phone} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].location_placeholder} onChange={handle_change_info} />*/}
															</div>
															<div className="col-6 col-md-6 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].address}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="text" name="address" value={dados.current.addresses[0].address} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].address_placeholder} onChange={handle_change_addresses} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-6 col-md-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].postal_code}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="text" name="postal_code" pattern="[0-9]{4}-[0-9]{3}" value={dados.current.addresses[0].postal_code} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-6 col-md-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].location}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="text" name="location" value={dados.current.addresses[0].location} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].location_placeholder} onChange={handle_change_addresses} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-6 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].village}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="text" name="village" value={dados.current.addresses[0].village} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].village_placeholder} onChange={handle_change_addresses} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-6 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].municipality}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="text" name="municipality" value={dados.current.addresses[0].municipality} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].municipality_placeholder} onChange={handle_change_addresses} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-6 col-md-4 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].date_birth}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="date" name="date_birth" value={dados.current.info.date_birth} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].date_birth_placeholder} onChange={handle_change_info} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-6 col-md-4 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].age}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="number" name="age" min={1} value={dados.current.info.age} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].age_placeholder} onChange={handle_change_info} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-6 col-md-4 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].place_birth}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="text" name="place_birth" value={dados.current.addresses[0].place_birth} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].place_birth_placeholder} onChange={handle_change_addresses} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-12 col-sm-6 col-md-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].id_type}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																								
																<select className="form-select rounded-0" aria-label="Select ID Type" name='id_type' value={dados.current.info.id_type} onChange={handle_change_info}>
																	<option value="id_type_citizen_card">{language[lang].id_type_citizen_card}</option>
																	<option value="id_type_identity_card">{language[lang].id_type_identity_card}</option>
																	<option value="id_type_passport">{language[lang].id_type_passport}</option>
																</select>
																
															</div>
															<div className="col-12 col-sm-6 col-md-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].id_number}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="number" name="id_number" pattern="\d*" inputMode='numeric' maxLength="11" value={dados.current.info.id_number} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].id_number_placeholder} onChange={handle_change_info} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-12 col-sm-6 col-md-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].id_validity}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="date" name="id_validity" value={dados.current.info.id_validity} className="form-control mb-3 mb-lg-0 rounded-0" /*placeholder={language[lang].id_validity_placeholder}*/ onChange={handle_change_info} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-12 col-sm-6 col-md-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">NIF<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="text" name="nif" pattern={pattern_vat} minLength="9" inputMode='numeric' value={dados.current.info.nif} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].nif_placeholder} onChange={handle_change_info} required={course_registration_operation ? true : false} />
															</div>
															<div className="col-12 col-sm-6 mb-3">
																<label className="col-form-label fs-6 fw-bold">NIB/IBAN<span className={course_registration_operation && financed_course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<div className='input-group'>
																	<span className="input-group-text" id="default-iban">PT50</span>
																	<input type="text" name="nib_iban" inputMode='numeric' value={dados.current.info.nib_iban} className="form-control mb-3 mb-lg-0 rounded-0" aria-describedby="default-iban" placeholder={language[lang].nib_iban_placeholder} onChange={handle_change_info} required={course_registration_operation && financed_course_registration_operation ? true : false} />
																</div>
															</div>

															<div className="col-12 mb-3">
																<div className="row">
																	<h3 className="fw-bolder mb-3">{language[lang].educational_background}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></h3>
																	<label className="col-form-label fw-bold fs-6 d-none">{language[lang].educational_background}</label>
																	{
																		aQualificacaoNivel.map( ( v , k ) => {
																			return (
																				<div className="col-6 col-sm-3 mb-2" key={k}>
																					<input
																						id={"qualifications_" + k}
																						type="radio"
																						//className='form-check-input'
																						name="qualifications"
																						value={v.value}
																						data-level={v.level}
																						data-name={v.label}
																						checked={dados.current.info.qualifications !== undefined && dados.current.info.qualifications.id === v.value ? true : false}
																						onChange={handle_change_info_qualifications}
																						required={course_registration_operation ? true : false}
																					/>
																					<label className="assec-pl-5" htmlFor={"qualifications_" + k}>{v.label}</label>
																				</div>
																			)
																		})
																	}
																</div>
															</div>
															<div className="col-12 col-sm-4 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].formation_area}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																<input type="text" name="formation_area" value={dados.current.info.formation_area} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].formation_area_placeholder} onChange={handle_change_info} />
															</div>
															<div className="col-12 mb-3">
																<div className="row">
																	<h3 className="fw-bolder mb-3">{language[lang].employment_status}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></h3>
																	<label className="col-form-label fw-bold fs-6 d-none">{language[lang].employment_status}</label>
																	{
																		situacao_emprego.map( ( v , k ) => {
																			return (
																				<div className="col-6 col-sm-4 mb-2" key={k}>
																					<input
																						id={"employment_status_" + k}
																						type="radio"
																						name="employment_status"
																						value={v}
																						checked={dados.current.info.employment !== undefined && dados.current.info.employment.employment_status === v ? true : false}
																						onChange={handle_change_info_employment}
																						required={course_registration_operation ? true : false}
																					/>
																					<label className="assec-pl-5" htmlFor={"employment_status_" + k}>{v}</label>
																				</div>
																			)
																		})
																	}
																</div>
															</div>
															{
																dados.current.info.employment !== undefined && (dados.current.info.employment.employment_status === 'Desempregado de longa duração (> 12 meses)' || dados.current.info.employment.employment_status === 'Desempregado à procura de novo emprego (não DLD)') ?

																	<div className="col-12 mb-3">
																		<div className="row">

																			<div className="col-6 col-md-4 mb-3">
																				<label className="col-form-label fs-6 fw-bold">{language[lang].iefp_registration_date}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
																				<input 
																					type="date"
																					name="iefp_registration_date"
																					value={dados.current.info.employment.iefp_registration_date !== undefined ? dados.current.info.employment.iefp_registration_date : ''}
																					className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].iefp_registration_date_placeholder}
																					onChange={handle_change_info_employment} 
																					required={course_registration_operation ? true : false}
																				/>
																			</div>
																		</div>
																	</div>

																: null
															}
															{
															dados.current.info.employment !== undefined && dados.current.info.employment.employment_status === 'Empregado por conta de outrem' ?

																<div className="col-12 mb-3">
																	<div className="row">

																		<div className="col-6 col-md-4 mb-3">
																			<label className="col-form-label fs-6 fw-bold">{language[lang].employer_entity}</label>
																			<input type="text" name="employer_entity" value={dados.current.info.employment.employer_entity} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].employer_entity_placeholder} onChange={handle_change_info_employment} />
																		</div>

																		<div className="col-6 col-md-4 mb-3">
																			<label className="col-form-label fs-6 fw-bold">{language[lang].business_sector}</label>
																			<input type="text" name="business_sector" value={dados.current.info.employment.business_sector} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].business_sector_placeholder} onChange={handle_change_info_employment} />
																		</div>

																		<div className="col-6 col-md-4 mb-3">
																			<label className="col-form-label fs-6 fw-bold">{language[lang].employment_role}</label>
																			<input type="text" name="employment_role" value={dados.current.info.employment.employment_role} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].employment_role_placeholder} onChange={handle_change_info_employment} />
																		</div>
																	</div>
																</div>

															: null
															}
															<div className="col-12">
																<h3 className="fw-bolder">{language[lang].household}</h3>
															</div>
															<div className="col-6 col-sm-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].household_total}</label>
																<input type="number" name="household_total" value={dados.current.info.household !== undefined && dados.current.info.household.household_total} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].household_total_placeholder} onChange={handle_change_info_household} />
															</div>
															<div className="col-6 col-sm-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].household_unemployed}</label>
																<input type="number" name="household_unemployed" value={dados.current.info.household !== undefined && dados.current.info.household.household_unemployed} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].household_unemployed_placeholder} onChange={handle_change_info_household} />
															</div>
															<div className="col-6 col-sm-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].household_dependants}</label>
																<input type="number" name="household_dependants" value={dados.current.info.household !== undefined && dados.current.info.household.household_dependants} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].household_dependants_placeholder} onChange={handle_change_info_household} />
															</div>
															<div className="col-6 col-sm-3 mb-3">
																<label className="col-form-label fs-6 fw-bold">{language[lang].household_inactive}</label>
																<input type="number" name="household_inactive" value={dados.current.info.household !== undefined && dados.current.info.household.household_inactive} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].household_inactive_placeholder} onChange={handle_change_info_household} />
															</div>
														</div>

														<div className="card-footer d-flex justify-content-end py-3 px-5 d-none">
															<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
																<span>{language[lang].cancel}</span>
															</Link>

															<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
																<span>{language[lang].delete}</span>
															</button>

															<button type="submit" form="form" className="btn btn-primary">
																<span>{language[lang].save}</span>
															</button>
														</div>
													</div>

												</form>
											</div>
										</div>

										<div className="card mt-5">
											<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_documentos">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].documents}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></h3>
												</div>
											</div>

											<div id="div_entidade_documentos" className="collapse show">
												<div className="card-body border-top p-4">
													<div className='row'>
														<div className="col-6 div-file-id mb-5">
															<label className="col-form-label fw-bold fs-6">{language[lang].doc_id}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>
															<div className="dropzone-panel mb-lg-0 mb-2">
																<div className="div-form-input col-12 custom-file">
																	<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-file-id"}>{language[lang].doc_choose}</label>
																	<input
																		id={"input-file-id"}
																		type="file"
																		accept="application/pdf"
																		data-type={'id'}
																		className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																		onChange={onChangeHandlerFile}
																	/>
																	<div className={"spinner-border position-absolute" + is_uploading['id']} role="status">
																		<span className="visually-hidden">Loading...</span>
																	</div>
																	
																	{
																	dados.current.info['files'] !== undefined ?
																		dados.current.info.files.map((el_f, k_f) => {
																			if(el_f.type === 'id') {
																				return (
																					<div key={k_f} className='d-flex align-items-center mt-3'>
																						<i className="bi bi-bookmark me-2"></i>
																						<a href={el_f.link} alt={el_f.name} title={el_f.name} target='_blank' rel="noreferrer">{el_f.name}</a>
																						<button type="button" onClick={() => removeUserDocument(el_f.type, k_f)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																							<i className="bi bi-x fs-4 pe-1"></i>
																						</button>
																					</div>
																				)
																			}
																			else {
																				return null
																			}
																		})
																	:
																		null
																	}

																	{
																	files_upload_name.map((el_f, k_f) => {
																		if(el_f.type === 'id') {
																			return (
																				<p key={k_f} className=' mt-3'>
																					<i className="bi bi-bookmark me-2"></i>
																					{el_f.name}
																				</p>
																			)
																		}
																		else {
																			return null
																		}
																	})
																	}

																</div>
															</div>

														</div>

														<div className="col-6 div-file-certificate mb-5">
															<label className="col-form-label fw-bold fs-6">{language[lang].doc_certificate}<span className={course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>

															<div className="dropzone-panel mb-lg-0 mb-2">
																<div className="div-form-input col-12 custom-file">
																	<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-file-certificate"}>{language[lang].doc_choose}</label>
																	<input
																		id={"input-file-certificate"}
																		type="file"
																		accept="application/pdf"
																		data-type={'certificate'}
																		className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																		onChange={onChangeHandlerFile}
																	/>

																	<div className={"spinner-border position-absolute" + is_uploading['certificate']} role="status">
																		<span className="visually-hidden">Loading...</span>
																	</div>

																	{
																	dados.current.info['files'] !== undefined ?
																		dados.current.info.files.map((el_f, k_f) => {
																			if(el_f.type === 'certificate') {
																				return (
																					<div key={k_f} className='d-flex align-items-center mt-3'>
																						<i className="bi bi-bookmark me-2"></i>
																						<a href={el_f.link} alt={el_f.name} title={el_f.name} target='_blank' rel="noreferrer">{el_f.name}</a>
																						<button type="button" onClick={() => removeUserDocument(el_f.type, k_f)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																							<i className="bi bi-x fs-4 pe-1"></i>
																						</button>
																					</div>
																				)
																			}
																			else {
																				return null
																			}
																		})
																	:
																		null
																	}

																	{
																	files_upload_name.map((el_f, k_f) => {
																		if(el_f.type === 'certificate') {
																			return (
																				<p key={k_f} className=' mt-3'>
																					<i className="bi bi-bookmark me-2"></i>
																					{el_f.name}
																				</p>
																			)
																		}
																		else {
																			return null
																		}
																	})
																	}
																</div>
															</div>
														</div>

														<div className="col-6 div-file-iban mb-5">
															<label className="col-form-label fw-bold fs-6">{language[lang].doc_iban}<span className={course_registration_operation && financed_course_registration_operation ? 'text-danger': 'd-none'}>&#42;</span></label>

															<div className="dropzone-panel mb-lg-0 mb-2">
																<div className="div-form-input col-12 custom-file">
																	<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-file-iban"}>{language[lang].doc_choose}</label>
																	<input
																		id={"input-file-iban"}
																		type="file"
																		accept="application/pdf"
																		data-type={'iban'}
																		className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																		onChange={onChangeHandlerFile}
																	/>

																	<div className={"spinner-border position-absolute" + is_uploading['iban']} role="status">
																		<span className="visually-hidden">Loading...</span>
																	</div>

																	{
																	dados.current.info['files'] !== undefined ?
																		dados.current.info.files.map((el_f, k_f) => {
																			if(el_f.type === 'iban') {
																				return (
																					<div key={k_f} className='d-flex align-items-center mt-3'>
																						<i className="bi bi-bookmark me-2"></i>
																						<a href={el_f.link} alt={el_f.name} title={el_f.name} target='_blank' rel="noreferrer">{el_f.name}</a>
																						<button type="button" onClick={() => removeUserDocument(el_f.type, k_f)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																							<i className="bi bi-x fs-4 pe-1"></i>
																						</button>
																					</div>
																				)
																			}
																			else {
																				return null
																			}
																		})
																	:
																		null
																	}

																	{
																	files_upload_name.map((el_f, k_f) => {
																		if(el_f.type === 'iban') {
																			return (
																				<p key={k_f} className=' mt-3'>
																					<i className="bi bi-bookmark me-2"></i>
																					{el_f.name}
																				</p>
																			)
																		}
																		else {
																			return null
																		}
																	})
																	}
																</div>
															</div>
														</div>
													</div>

													<div className='row'>
														<div className='col-12 mb-3'>
															<h3 className="fw-bolder m-0">{language[lang].empregado}</h3>
														</div>
														<div className="col-6 div-file-emprego mb-5">
															<label className="col-form-label fw-bold fs-6">{language[lang].doc_emprego}</label>

															<div className="dropzone-panel mb-lg-0 mb-2">
																<div className="div-form-input col-12 custom-file">
																	<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-file-emprego"}>{language[lang].doc_choose}</label>
																	<input
																		id={"input-file-emprego"}
																		type="file"
																		accept="application/pdf"
																		data-type={'emprego'}
																		className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																		onChange={onChangeHandlerFile}
																	/>

																	<div className={"spinner-border position-absolute" + is_uploading['emprego']} role="status">
																		<span className="visually-hidden">Loading...</span>
																	</div>


																	{
																	dados.current.info['files'] !== undefined ?
																		dados.current.info.files.map((el_f, k_f) => {
																			if(el_f.type === 'emprego') {
																				return (
																					<div key={k_f} className='d-flex align-items-center mt-3'>
																						<i className="bi bi-bookmark me-2"></i>
																						<a href={el_f.link} alt={el_f.name} title={el_f.name} target='_blank' rel="noreferrer">{el_f.name}</a>
																						<button type="button" onClick={() => removeUserDocument(el_f.type, k_f)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																							<i className="bi bi-x fs-4 pe-1"></i>
																						</button>
																					</div>
																				)
																			}
																			else {
																				return null
																			}
																		})
																	:
																		null
																	}

																	{
																	files_upload_name.map((el_f, k_f) => {
																		if(el_f.type === 'emprego') {
																			return (
																				<p key={k_f} className=' mt-3'>
																					<i className="bi bi-bookmark me-2"></i>
																					{el_f.name}
																				</p>
																			)
																		}
																		else {
																			return null
																		}
																	})
																	}
																</div>
															</div>
														</div>

														<div className="col-6 div-file-emprego-horario mb-5">
															<label className="col-form-label fw-bold fs-6">{language[lang].doc_emprego_horario}</label>

															<div className="dropzone-panel mb-lg-0 mb-2">
																<div className="div-form-input col-12 custom-file">
																	<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-file-emprego-horario"}>{language[lang].doc_choose}</label>
																	<input
																		id={"input-file-emprego-horario"}
																		type="file"
																		accept="application/pdf"
																		data-type={'emprego-horario'}
																		className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																		onChange={onChangeHandlerFile}
																	/>

																	<div className={"spinner-border position-absolute" + is_uploading['emprego_horario']} role="status">
																		<span className="visually-hidden">Loading...</span>
																	</div>

																	{
																	dados.current.info['files'] !== undefined ?
																		dados.current.info.files.map((el_f, k_f) => {
																			if(el_f.type === 'certificate-horario') {
																				return (
																					<div key={k_f} className='d-flex align-items-center mt-3'>
																						<i className="bi bi-bookmark me-2"></i>
																						<a href={el_f.link} alt={el_f.name} title={el_f.name} target='_blank' rel="noreferrer">{el_f.name}</a>
																						<button type="button" onClick={() => removeUserDocument(el_f.type, k_f)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																							<i className="bi bi-x fs-4 pe-1"></i>
																						</button>
																					</div>
																				)
																			}
																			else {
																				return null
																			}
																		})
																	:
																		null
																	}

																	{
																	files_upload_name.map((el_f, k_f) => {
																		if(el_f.type === 'certificate-horario') {
																			return (
																				<p key={k_f} className=' mt-3'>
																					<i className="bi bi-bookmark me-2"></i>
																					{el_f.name}
																				</p>
																			)
																		}
																		else {
																			return null
																		}
																	})
																	}
																</div>
															</div>
														</div>
													</div>

													<div className='row'>
														<div className='col-12 mb-3'>
															<h3 className="fw-bolder m-0">{language[lang].desempregado}</h3>
														</div>
														<div className="col-12 div-file-desempregado mb-5">
															<label className="col-form-label fw-bold fs-6">{language[lang].doc_desempregado}</label>

															<div className="dropzone-panel mb-lg-0 mb-2">
																<div className="div-form-input col-12 custom-file">
																	<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-file-desempregado"}>{language[lang].doc_choose}</label>
																	<input
																		id={"input-file-desempregado"}
																		type="file"
																		accept="application/pdf"
																		data-type={'desempregado'}
																		className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																		onChange={onChangeHandlerFile}
																	/>

																	<div className={"spinner-border position-absolute" + is_uploading['desempregado']} role="status">
																		<span className="visually-hidden">Loading...</span>
																	</div>

																	{
																	dados.current.info['files'] !== undefined ?
																		dados.current.info.files.map((el_f, k_f) => {
																			if(el_f.type === 'desemprego') {
																				return (
																					<div key={k_f} className='d-flex align-items-center mt-3'>
																						<i className="bi bi-bookmark me-2"></i>
																						<a href={el_f.link} alt={el_f.name} title={el_f.name} target='_blank' rel="noreferrer">{el_f.name}</a>
																						<button type="button" onClick={() => removeUserDocument(el_f.type, k_f)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																							<i className="bi bi-x fs-4 pe-1"></i>
																						</button>
																					</div>
																				)
																			}
																			else {
																				return null
																			}
																		})
																	:
																		null
																	}

																	{
																	files_upload_name.map((el_f, k_f) => {
																		if(el_f.type === 'desemprego') {
																			return (
																				<p key={k_f} className=' mt-3'>
																					<i className="bi bi-bookmark me-2"></i>
																					{el_f.name}
																				</p>
																			)
																		}
																		else {
																			return null
																		}
																	})
																	}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div className="card mt-5">
											<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
												</div>
											</div>
											<div id="div_entidade_password" className="collapse show">
												<form id="form_1" onSubmit={handleSubmitPassword}>

													<div className="card-body border-top p-4">

														<div className="row mb-6">
															<div className="col-md-4 fv-row">
																<label className="col-form-label fs-6 fw-bold">{language[lang].username_email}</label>
																<input type="text" name="username" value={dados.current.info.username} /*pattern={'Administrador' !== getTokenInfo().profile ? pattern_email : ''}*/ className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} required />
															</div>
															<div className="col-md-4 fv-row">
																<label className="col-form-label fs-6 fw-bold">{language[lang].password}</label>
																<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
															</div>
															<div className="col-md-4 fv-row">
																<label className="col-form-label fs-6 fw-bold">{language[lang].password_confirmation}</label>
																<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
															</div>
														</div>

														<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
															<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
																<span>{language[lang].cancel}</span>
															</Link>

															<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
																<span>{language[lang].delete}</span>
															</button>

															<button type="submit" form="form" className="btn btn-primary">
																<span>{language[lang].save}</span>
															</button>
														</div>
													</div>
												</form>
											</div>
										</div>
									</div>
								</div>
								{ ('Administrador' === getTokenInfo().profile) && dados.current.info['courses'] !== undefined && dados.current.info['courses'].length > 0 ? (
									<div className='row'>
										<div className='col-12 mb-2'>
											<h3 className="fw-bolder">{language[lang].formation_registration_2}</h3>
											<label className="d-block col-form-label fs-6 fw-bold border-top">Curso</label>
										</div>

										{
											
											dados.current.info.courses.map((elem, index) => {
												
												return (
													<div key={index} className='col-12'>
														<div className='d-flex align-items-center'>
															<span className='fw-bold'>{elem.course_name}</span>
															&nbsp;&#45;&nbsp;
															<span className={elem.request_status === 'accepted' ? 'text-success': (elem.request_status === 'rejected' ? 'text-danger' : 'text-warning')}>{language[lang][elem.request_status]}</span>
															<button type="button" onClick={() => removeCourseRegistration(elem.course_id, index)} alt={language[lang].formation_registration_remove} title={language[lang].formation_registration_remove}>
																<i className="bi bi-x fs-4 pe-1"></i>
															</button>
														</div>
													</div>
												)
											})
										}
									</div>
								) : null }
							</div>
						</div>

						<div className={'dash-cards footer'}>
							<nav className="navbar bottom-navbar navbar-light">
								<div className="navbar-footer">
									<ul className="navbar-nav float-left"></ul>
									<ul className="navbar-nav float-right">
										{ delete_permission ? (
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
													{/*<img alt='' src={'./img/cancelar.svg'} />
													<span>{language[lang].cancel}</span>*/}
													<img alt={language[lang].back} src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li>
										) : null }
										{ course_registration_operation ? (
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: '/courses_view', state: { item: {id: props.location.state.course_id}, operation: 'view' } }}  >
													<img alt={language[lang].back} src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li>
										) : null }
										{ delete_permission ? (
											<li className={"nav-item " + show_delete_button}>
												<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
													<img alt={language[lang].delete} src={'./img/eliminar_b.svg'} />
													<span>{language[lang].delete}</span>
												</button>
											</li>
										) : null }
										{ course_registration_operation && 0 ? (
											<li className={"nav-item "}>
													<button type="button" /*onClick={() => finishCourseRegistration()}*/ className="nav-link">
														<span>{language[lang].formation_registration_finish}</span>
													</button>
												</li>
										) : null }

										<li className="nav-item">
											<button type="submit" form="form" className="nav-link">
												<img alt={language[lang].save} src={'./img/save.svg'} />
												<span>
													{
													course_registration_operation && course_registration_operation_save ? 
														language[lang].formation_registration_finish 
													: 
														language[lang].save}</span>
											</button>
										</li>
									</ul>
								</div>
							</nav>
						</div>
					</main>

}
